import { Component, Vue, Prop } from 'vue-property-decorator';
import MindsetsPanel from '@/components/proficiency/mindsets-panel/mindsets-panel';
import CommunityPanel from '../community-panel/community-panel';
import KnowledgePanel from '../knowledge-panel/knowledge-panel';
import { SubjectModel } from '@/models/taxonomy/subject';
import FacetRoutInfoComponent from '@/components/showcase/facet-route-info/facet-route-info';
import { UserClassModel } from '@/models/class/class';

@Component({
  name: 'facets-info-panel',
  components: {
    'mindsets-panel': MindsetsPanel,
    'knowledge-panel': KnowledgePanel,
    'community-panel': CommunityPanel,
    'facet-route-info': FacetRoutInfoComponent,
  },
})
export default class FacetsInfoPanel extends Vue {

  @Prop()
  private userId!: string;

  @Prop()
  private month!: string;

  @Prop()
  private year!: string;

  @Prop()
  private activeFacets!: SubjectModel[];

  @Prop()
  private facetsCompetencyMatrix!: any;

  @Prop()
  private isActiveProficiency?: boolean;

  @Prop()
  private userClassList!: UserClassModel[];

  @Prop()
  private isShowcasePage!: boolean;

  private get activeToggleList() {
    return this.isActiveProficiency ? '' : 'ShowPortfolioContainer';
  }

  get activeFacetsCompetencyMatrix() {
    return this.activeFacets.map( (activeFacet: SubjectModel) => {
      return this.facetsCompetencyMatrix.find( (
        facetCompetencyMatrix: any) => facetCompetencyMatrix.subjectCode === activeFacet.code);
    });
  }

  private activeTab: object = {
    label: 'Knowledge',
    component: 'knowledge-panel',
  };

  private get isSuperUser() {
    return this.$access.hasPermission('all', 'all');
  }

  private tabItems = [
    {
      label: 'Knowledge',
      component: 'knowledge-panel',
    },
    {
      label: this.isShowcasePage ? 'Journey' : 'Mindset',
      component: this.$access.isShowcaseDemo ? 'facet-route-info' : 'mindsets-panel',
    },
    {
      label: 'Citizenship',
      component: 'community-panel',
    },
  ];

  private onSelectPortfolioStat(portfolioStat: any) {
    this.$emit('onSelectPortfolioStat', portfolioStat);
  }

  private onSelectTab(tabItem: any) {
    this.activeTab = tabItem;
  }


}
